export default __webpack_public_path__ + "static/media/import.daeec133.svg";